import { useCallback, useEffect, useState } from 'react';
import Cookies from 'js-cookie';

const getCookieWithDefault = (key: string, defaultValue: string) => {
  const value = Cookies.get(key);

  if (value) {
    return value;
  }

  Cookies.set(key, defaultValue);
  return defaultValue;
};

/**
 * @param key - cookie ID to use **NOTE** this hook does not support changing this key after initial render
 * @param defaultValue - value to set cookie to if it does not exist
 */
export const useCookieValue = (key: string, defaultValue: string): [string, (newValue: string) => void] => {
  const [value, setValue] = useState<string>(() => getCookieWithDefault(key, defaultValue));

  const handleChange = useCallback(
    (newValue: string) => {
      Cookies.set(key, newValue);
      setValue(newValue);
    },
    [key]
  );

  useEffect(() => {
    const handleStorageChange = () => {
      setValue(getCookieWithDefault(key, defaultValue));
    };

    window.addEventListener('storage', handleStorageChange);

    return () => window.removeEventListener('storage', handleStorageChange);
  }, [defaultValue, key]);

  return [value, handleChange];
};
